export const PARTNERS = [
    {src: 'OTI.png', alt: 'OTI Logo'},
    /* {src: 'upe13.png', alt: 'upe13 Logo'}, */ //GMIF et UPE (en attente d'accord pour mettre sur le site)
    {src: 'Afpa.png', alt: 'Afpa Logo'},
    {src: 'b2rhconseil.png', alt: 'b2rhconseil Logo'},
    {src: 'CFM.png', alt: 'CFM Logo'},
    /* {src: 'GMIF.png', alt: 'GMIF Logo'}, */ //GMIF et UPE (en attente d'accord pour mettre sur le site)
    /* {src: 'juriskrh.png', alt: 'juriskRH Logo'}, */
    {src: 'MEDINSOFT.png', alt: 'MEDINSOFT Logo'},
    {src: 'OLEUM.png', alt: 'OLEUM Logo'},
    {src: 'franceTravail.png', alt: 'France travail Logo'},
    {src: 'qualitis.png', alt: 'qualitis Logo'},
    {src: 'ABJobconseil.png', alt: 'ABJobconseil Logo'},
    {src: 'ifra.png', alt: 'Ifra Logo'},
    {src: 'formafon.png', alt: 'Formafon Logo'},
    {src: 'mikado.png', alt: 'Mikado Logo'},
    {src: 'VAUCLUSE.png', alt: 'Vaucluse Logo'},
    {src: 'EDF.png', alt: 'EDF Logo'},
    {src: 'IFARE.png', alt: 'IFARE Logo'},
    {src: 'gip.png', alt: 'GIP Logo'}
]